<div class="user" *transloco="let t; read: 'global.mfa'">
  <h2 *ngIf="step === 'code'" class="user__heading">{{ t('title') }}</h2>

  <!-- Loading state -->
  <div *ngIf="loading" class="mfa__loading">
    <div class="mfa__loading__spinner"></div>
    <p class="mfa__loading__text">{{ t('loading') }}</p>
  </div>

  <!-- Content when loaded -->
  <div *ngIf="!loading">
    <div *ngIf="step === 'code'" class="user__section">
      <div class="user__section__data user__section__data--full-width">
        <h2 class="user__section__data__heading" [innerHTML]="t('step1')"></h2>
        <div class="user__section__data__hint" [innerHTML]="t('intro')"></div>
        <div class="user__section__data__value">
          <div class="mfa__qr mfa__qr--plain">
            <!-- QR Code Loading State -->
            <div *ngIf="qrLoading" class="mfa__qr__loading">
              <div class="mfa__qr__spinner"></div>
              <p class="mfa__qr__loading-text">{{ t('qrLoading') }}</p>
            </div>

            <!-- QR Code Error State -->
            <div *ngIf="qrError" class="mfa__qr__error">
              <div class="mfa__qr__error-icon"></div>
              <p class="mfa__qr__error-text">{{ t('qrError') }}</p>
              <button type="button" class="mfa__qr__retry" (click)="beginSetup()">
                {{ t('retry') }}
              </button>
            </div>

            <!-- QR Code Success State (no background container) -->
            <div *ngIf="!qrLoading && !qrError && qrDataUri">
              <img
                [src]="qrDataUri"
                [alt]="t('qrCodeAlt')"
                (load)="onQrImageLoad()"
                (error)="onQrImageError()"
                class="mfa__qr__image" />
            </div>
          </div>
        </div>
      </div>

      <div class="user__section__data mfa__data--left mfa__data--manual" *ngIf="setup?.sharedKey as key">
        <div class="user__section__data__heading mfa__label--left">{{ t('manualLabel') }}</div>
        <div class="user__section__data__value">
          <div class="mfa__manual__container">
            <div class="mfa__manual__key">{{ key }}</div>
            <button type="button"
                    class="mfa__manual__copy"
                    [class.mfa__manual__copy--copying]="copying"
                    [attr.aria-label]="t('copy')"
                    (click)="copyKey()">
              {{ t('copy') }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <form *ngIf="step === 'verify'" [formGroup]="form" (ngSubmit)="verify()" class="user__section user__section--form">
        <div class="user__section__data mfa__data--left mfa__data--verify">
            <h2 class="user__section__data__heading" [innerHTML]="t('step2')"></h2>
            <div class="user__section__data__hint" [innerHTML]="t('verifyIntro')"></div>
        </div>
      <div class="user__section__data mfa__data--left mfa__data--verify">
        <div class="user__section__data__value">
          <div class="mfa__input-container">
            <ha-input
              type="text"
              class="mfa__input"
              formControlName="verificationCode"
              [label]="t('codeLabel')"
              autocomplete="one-time-code"
              inputmode="numeric"
              [maxlength]="6"
              placeholder="000000">
            </ha-input>
          </div>
          <div class="mfa__input-error" *ngIf="!form.controls.verificationCode.invalid && error">
            {{ t(error) }}
          </div>
          <div class="mfa__input-error"
               *ngIf="form.controls.verificationCode.touched
                      && form.controls.verificationCode.invalid">
            {{ t('codeError') }}
          </div>
        </div>
      </div>
    </form>

    <div class="user__actions">
      <button *ngIf="step === 'code'" type="button" class="user__actions__cancel" (click)="cancel()">
        {{ t('cancel') }}
      </button>
      <button *ngIf="step === 'verify'" type="button" class="user__actions__cancel" (click)="step = 'code'">
        {{ t('back') }}
      </button>
    <button type="button"
            *ngIf="step === 'code'"
            class="user__actions__verify"
            (click)="step = 'verify'"
            >
        {{ t('next') }}
      </button>
    <button type="button"
            *ngIf="step === 'verify'"
            class="user__actions__verify"
            (click)="verify()"
            [disabled]="form.invalid || form.pristine"
            [class.user__actions__verify--disabled]="form.invalid || form.pristine"
            [loading]="ConfirmSetupAction">
        {{ t('verify') }}
      </button>
    </div>
  </div>
</div>

